import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import EmptyError from "../../../components/EmptyError";
import Loading from "../../../components/Loading";
import MenuTrainee from "../../../components/MenuTrainee";
import StatusFlag from "../../../components/StatusFlag";
import TableResponsive from "../../../components/TableResponsive";
import usePaymentSlip from "../../../hooks/api/usePaymentSlip";
import useFormat from "../../../hooks/utils/useFormat";
import Dropdown2 from "../../../components/Dropdown";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";

export default function Financeiro() {
  const { data: paymentSlips2, setquery: setpaymentSlipQuery } = usePaymentSlip({ is_trainee: true });
  const { me } = useWrapper();
  const { formatReal, formatDate } = useFormat();

  useEffect(() => {
    setpaymentSlipQuery(`?paginate=false&trainee_id=${me.id}`);
  }, [me.id, setpaymentSlipQuery]);

  return (
    <>
      <Main className={style.mainUser}>
        <Content noBG="true">
          <Row>
            <Col md={12} lg={2}>
              <MenuTrainee />
            </Col>
            <Col>
              {!!paymentSlips2 ? (
                <SubContent>
                  <Row>
                    <Col>
                      <div className="mb-4">
                        <h2 className="form-title">Financeiro</h2>
                        <p className="small-label">
                          Se você já pagou um boleto e ele ainda não está com o Status de "Pago", não se preocupe, ele
                          pode demorar até 3 dias úteis para a confirmação.
                        </p>
                      </div>
                      <TableResponsive
                        table={{
                          head: [
                            { data: "Código" },
                            { data: "Valor" },
                            { data: "A Pagar/Pago" },
                            { data: "Vencimento/Pagamento" },
                            { data: "Parcela" },
                            { data: "Status" },
                            { data: "Origem" },
                            { data: "Ações" },
                          ],
                          body:
                            paymentSlips2?.data
                              ?.filter(__payment => __payment?.status !== "Cancelado")
                              ?.map((__payment, __payment_i) => ({
                                disabled: __payment.status === "Cancelado",
                                data: [
                                  {
                                    element: <span>{__payment.id}</span>,
                                  },
                                  {
                                    element: <span>{formatReal(__payment.value)}</span>,
                                  },
                                  {
                                    element: (
                                      <span>
                                        <b>
                                          {formatReal(
                                            __payment.value_paid ||
                                              (__payment.value || 0) + (__payment.value_juros || 0),
                                          )}
                                        </b>
                                      </span>
                                    ),
                                  },
                                  {
                                    element: <span>{formatDate(__payment.payment_date || __payment.due_date, 2)}</span>,
                                  },
                                  {
                                    element: (
                                      <span>
                                        {__payment.quota}/{__payment.quotas_total}
                                      </span>
                                    ),
                                  },
                                  {
                                    element: (
                                      <span>
                                        <StatusFlag status={__payment.status} />
                                      </span>
                                    ),
                                  },
                                  {
                                    element: (
                                      <span>
                                        {__payment.payment_for}{" "}
                                        <span className="small-label">
                                          {!!__payment?.custom_payment?.name
                                            ? `(${__payment?.aditional_information || "1"} ${__payment?.custom_payment?.name})`
                                            : ""}
                                        </span>
                                      </span>
                                    ),
                                  },
                                  {
                                    element: (
                                      <>
                                        {!(__payment.status === "Cancelado" || __payment.status === "Pago") && (
                                          <div className="text-right">
                                            <Dropdown2
                                              toggle={<span>...</span>}
                                              menu={[
                                                {
                                                  label: "Download do Boleto",
                                                  action: () => {
                                                    if (__payment.boleto_url) {
                                                      window.open(__payment.boleto_url);
                                                    } else {
                                                      toast.error("O download deste boleto ainda está indisponível");
                                                    }
                                                  },
                                                },
                                                {
                                                  label: "Copiar Código",
                                                  action: () => {
                                                    if (__payment.bar_code) {
                                                      navigator.clipboard.writeText(__payment.bar_code);
                                                      toast.success("Código do Boleto copiado.");
                                                    } else {
                                                      toast.error("Esse boleto ainda não foi gerado.");
                                                    }
                                                  },
                                                },
                                              ]}
                                            />
                                          </div>
                                        )}
                                      </>
                                    ),
                                  },
                                ],
                              })) || [],
                        }}
                      />
                      {!paymentSlips2.data.length > 0 && (
                        <EmptyError
                          msg={
                            <p>
                              Não encontramos nenhum resultado para sua busca.
                              <br />
                              Tente novamente.
                            </p>
                          }
                        />
                      )}
                    </Col>
                  </Row>
                </SubContent>
              ) : (
                <SubContent>
                  <Loading />
                </SubContent>
              )}
            </Col>
          </Row>
        </Content>
      </Main>
    </>
  );
}
